import React, {useState, useEffect} from "react";
import './gallerygrid.css';
import { useLocation, Link } from "react-router-dom";

const Gallerygrid = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [sportlength, setSportlength] = useState(0);

    const images = [
        { id: 0, src: "https://optimize.sirv.com/silwane/teambuild1.webp", majorevents: "team building", spid: 0 },
        { id: 1, src: "https://optimize.sirv.com/silwane/teambuild2.webp", majorevents: "team building", spid: 1 },
        { id: 2, src: "https://optimize.sirv.com/silwane/teambuild3.webp", majorevents: "team building", spid: 2},
        { id: 3, src: "https://optimize.sirv.com/silwane/naturewalk1.webp", majorevents: "nature walk", spid: 0 },
        { id: 4, src: "https://optimize.sirv.com/silwane/waterfalls1.webp", majorevents: "waterfalls", spid: 0 },
        { id: 5, src: "https://optimize.sirv.com/silwane/naturewalk2.webp", majorevents: "nature walk", spid: 1 },
        { id: 6, src: "https://optimize.sirv.com/silwane/waterfalls.webp", majorevents: "waterfalls", spid: 1 },
        { id: 7, src: "https://optimize.sirv.com/silwane/naturewalk3.webp", majorevents: "nature walk", spid: 2 },
        { id: 8, src: "https://optimize.sirv.com/silwane/waterfalls2.webp", majorevents: "waterfalls", spid: 2 },
        { id: 9, src: "https://optimize.sirv.com/silwane/waterfalls3.webp", majorevents: "waterfalls", spid: 3 },
        { id: 10, src: "https://optimize.sirv.com/silwane/waterfalls4.webp", majorevents: "waterfalls", spid: 4 },
        { id: 11, src: "https://optimize.sirv.com/silwane/waterfalls5.webp", majorevents: "waterfalls", spid: 5 },
        { id: 12, src: "https://optimize.sirv.com/silwane/naturewalk4.webp", majorevents: "nature walk", spid: 3 },
        { id: 13, src: "https://optimize.sirv.com/silwane/waterfall6.webp", majorevents: "waterfalls", spid: 6 },
        { id: 14, src: "https://optimize.sirv.com/silwane/damsite.webp", majorevents: "damsite", spid: 0 },
        { id: 15, src: "https://optimize.sirv.com/silwane/damsite1.webp", majorevents: "damsite", spid: 1 },
        { id: 16, src: "https://optimize.sirv.com/silwane/damsite2.webp", majorevents: "damsite", spid: 2 },
        { id: 17, src: "https://optimize.sirv.com/silwane/damsite3.webp", majorevents: "damsite", spid: 3},
        { id: 18, src: "https://optimize.sirv.com/silwane/damsite4.webp", majorevents: "damsite", spid: 4},
        { id: 19, src: "https://optimize.sirv.com/silwane/activity.webp", majorevents: "activities", spid: 0 },
        { id: 20, src: "https://optimize.sirv.com/silwane/activity2.webp", majorevents: "activities", spid: 1 },
        { id: 21, src: "https://optimize.sirv.com/silwane/activity3.webp", majorevents: "activities", spid: 2 },
        { id: 22, src: "https://optimize.sirv.com/silwane/activity4.webp", majorevents: "activities", spid: 3},
        { id: 23, src: "https://optimize.sirv.com/silwane/activity5.webp", majorevents: "activities", spid: 4},
        { id: 24, src: "https://optimize.sirv.com/silwane/activity6.webp", majorevents: "activities", spid: 5},
        { id: 25, src: "https://optimize.sirv.com/silwane/zip3.jpeg", majorevents: "activities", spid: 6},
        { id: 26, src: "https://optimize.sirv.com/silwane/jumpingcastle.jpeg", majorevents: "activities", spid: 7},
        { id: 27, src: "https://optimize.sirv.com/silwane/zip5edit.jpeg", majorevents: "activities", spid: 8},
        
    ];

    const location = useLocation();
    //location.state.data.sporttype;

    const sportstype = location.state.data.majorevents;
    const aboutevent = location.state.data.abt;

    useEffect(() => {
      
        const filteredImages = images.filter(
          (image) => image.majorevents === sportstype
        );
        setSportlength(filteredImages.length);
  
    }, [sportstype, images]);

    const handleImageClick = (index) => {
      setCurrentIndex(index);
      setIsOpen(true);
    };

    const handleClose = () => {
      setIsOpen(false);
    };
  
    const handlePrev = () => {
      const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
    };
  
    const handleNext = () => {
      const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
    };

    const handlePrevSport = () => {
      const newIndex = currentIndex === 0 ? sportlength - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
    };
  
    const handleNextSport = () => {
      const newIndex = currentIndex === sportlength - 1 ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
    };


    return (
      <>
          <div className="majoreventsimggridcont">
              <p className="majoreventsabout">{aboutevent}</p>
              {isOpen && (
                <div className="popupmajorevents">
                  {images.map((image, index) => (
                    <div className="majoreventsimgbuffer" key={image.id}>
                      {(image.majorevents === sportstype && image.spid === currentIndex) ?
                      <>
                        <img src={image.src} alt={`majorevents ${currentIndex}`} />
                        <button className="majoreventsarrow prev" onClick={handlePrevSport}>
                          &#10094;
                        </button>
                        <button className="majoreventsarrow next" onClick={handleNextSport}>
                          &#10095;
                        </button>
                        <button className="majoreventsclose" onClick={handleClose}>
                          &times;
                        </button>
                      </>
                      :(sportstype === "all" && index === currentIndex) &&
                      <>
                        <img src={image.src} alt={`majorevents ${currentIndex}`} />
                        <button className="majoreventsarrow prev" onClick={handlePrev}>
                          &#10094;
                        </button>
                        <button className="majoreventsarrow next" onClick={handleNext}>
                          &#10095;
                        </button>
                        <button className="majoreventsclose" onClick={handleClose}>
                          &times;
                        </button>
                      </>
                      }
                    </div>
                  ))}
                </div>
              )}
              <div className="majoreventsimggridsize">
                <div className="majoreventsimggrid">
                  {images.map((image, index) => (
                          <div className="majoreventsimgcont" key={image.id}>
                              {image.majorevents === sportstype ?
                                <img src={image.src} alt={`Grid ${image.spid + 1}`}  onClick={() => handleImageClick(image.spid)}/>
                                : sportstype === "all" &&
                                <img src={image.src} alt={`Grid ${image.id + 1}`} onClick={() => handleImageClick(image.id)} />
                              }
                          </div>
                  ))} 
                </div>
              </div>
          </div>
           
      </>
    );
  };
  
export default Gallerygrid;